import * as React from "react";
import type { FeatureNavModule, FeatureRouteModule } from "../types";
import { BarChart2 } from "lucide-react";
import { EvalPage } from "@/pages/eval";
import { EvalDatasetsPage } from "@/pages/eval-datasets";
import { EvalGradersPage } from "@/pages/eval-graders";
import { EvalCriteriaPage } from "@/pages/eval-criteria";
import { EvalRunsPage } from "@/pages/eval-runs";
import { EvalResultsPage } from "@/pages/eval-results";
import { EvalSummariesPage } from "@/pages/eval-summaries";

export const evalRoutes: FeatureRouteModule = {
  shellRoutes: [
    {
      path: "eval",
      handle: { title: "Eval" },
      element: React.createElement(EvalPage),
      children: [
        {
          path: "datasets",
          handle: { title: "Datasets" },
          element: React.createElement(EvalDatasetsPage, { headingLevel: "h2" }),
        },
        {
          path: "graders",
          handle: { title: "Graders" },
          element: React.createElement(EvalGradersPage, { headingLevel: "h2" }),
        },
        {
          path: "criteria",
          handle: { title: "Criteria" },
          element: React.createElement(EvalCriteriaPage, { headingLevel: "h2" }),
        },
        {
          path: "runs",
          handle: { title: "Runs" },
          element: React.createElement(EvalRunsPage, { headingLevel: "h2" }),
        },
        {
          path: "runs/:runId/results",
          handle: { title: "Results" },
          element: React.createElement(EvalResultsPage, { headingLevel: "h2" }),
        },
        {
          path: "runs/:runId/summaries",
          handle: { title: "Summary" },
          element: React.createElement(EvalSummariesPage, { headingLevel: "h2" }),
        },
      ],
    },
  ],
  shellRouteDefs: [
    {
      path: "/eval",
      title: "Eval",
      summary: "Datasets, graders, runs, and scored results for evaluation.",
    },
    {
      path: "/eval/datasets",
      title: "Eval datasets",
      summary: "Collections of input/output pairs for evaluation.",
    },
    {
      path: "/eval/graders",
      title: "Eval graders",
      summary: "Deterministic checks, rubrics, and human review definitions.",
    },
    {
      path: "/eval/criteria",
      title: "Eval criteria",
      summary: "Scoring criteria with thresholds and weights.",
    },
    {
      path: "/eval/runs",
      title: "Eval runs",
      summary: "Execute graders against datasets and track results.",
    },
    {
      path: "/eval/runs/:runId/results",
      title: "Eval results",
      summary: "Per-item, per-criterion scores from an eval run.",
    },
    {
      path: "/eval/runs/:runId/summaries",
      title: "Eval summary",
      summary: "Aggregated scores and pass rates per criterion.",
    },
  ],
};

export const evalNav: FeatureNavModule = {
  navGroups: [
    {
      label: "Evaluate",
      items: [
        {
          to: "/eval",
          label: "Eval",
          icon: BarChart2,
          end: false,
        },
      ],
    },
  ],
};
